import React from "react";
import { bool } from "prop-types";
import { Button } from "react-bootstrap";
import supportTeamImage1 from "resources/images/support-team-image-1.png";
import supportTeamImage2 from "resources/images/support-team-image-2.png";
import supportTeamImage3 from "resources/images/support-team-image-3.png";
import SupportTeamImage from "./SupportTeamImage";

const EmailSupportSection = (props) => {
  const { isAU } = props;

  const mailToUrl = isAU
    ? "au.customersupport@criteriacorp.com"
    : "techsupport@criteriacorp.com";

  return (
    <div className="email-support-section">
      <p>
        If something doesn’t look right or you need help setting up a job,
        contact support.
      </p>
      <div className="d-flex align-items-center mb-2">
        <div
          className="support-images d-flex mr-1 justify-content-center"
          style={{ flex: "0 0 113px" }}
        >
          <SupportTeamImage
            src={supportTeamImage1}
            alt="support team member 1"
            style={{ zIndex: 1003 }}
          />
          <SupportTeamImage
            src={supportTeamImage2}
            alt="support team member 2"
            style={{ zIndex: 1002, marginLeft: "-15px", marginRight: "-15px" }}
          />
          <SupportTeamImage
            src={supportTeamImage3}
            alt="support team member 3"
            style={{ zIndex: 1001 }}
          />
        </div>
        <div className="support-information">
          <div className="font-weight-bold">Your Support Team</div>
          <div>
            <a href={`mailto: ${mailToUrl}`}>{mailToUrl}</a>
          </div>
        </div>
      </div>
      <a href={`mailto: ${mailToUrl}`}>
        <Button variant="primary" className="text-center w-100">
          Email Support
        </Button>
      </a>
    </div>
  );
};

EmailSupportSection.propTypes = {
  isAU: bool,
};

export default EmailSupportSection;
